import { render, staticRenderFns } from "./ImageEffectsPropertiesListItem.vue?vue&type=template&id=47e4d8d1&scoped=true"
import script from "./ImageEffectsPropertiesListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageEffectsPropertiesListItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImageEffectsPropertiesListItem.vue?vue&type=style&index=0&id=47e4d8d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e4d8d1",
  null
  
)

export default component.exports